import { apiPost, apiGet, apiPut, apiDelete } from '../lib/api'

export const GROUP_ADD_START = 'GROUP_ADD_START'
export const GROUP_ADD_SUCCESS = 'GROUP_ADD_SUCCESS'
export const GROUP_ADD_ERROR = 'GROUP_ADD_ERROR'

export const GROUP_EDIT_START = 'GROUP_EDIT_START'
export const GROUP_EDIT_SUCCESS = 'GROUP_EDIT_SUCCESS'
export const GROUP_EDIT_ERROR = 'GROUP_EDIT_ERROR'

export const GROUP_LOAD_START = 'GROUP_LOAD_START'
export const GROUP_LOAD_SUCCESS = 'GROUP_LOAD_SUCCESS'
export const GROUP_LOAD_ERROR = 'GROUP_LOAD_ERROR'

export const GROUP_DELETE_START = 'GROUP_DELETE_START'
export const GROUP_DELETE_SUCCESS = 'GROUP_DELETE_SUCCESS'
export const GROUP_DELETE_ERROR = 'GROUP_DELETE_ERROR'

export const GROUPS_LOAD_START = 'GROUPS_LOAD_START'
export const GROUPS_LOAD_SUCCESS = 'GROUPS_LOAD_SUCCESS'
export const GROUPS_LOAD_ERROR = 'GROUPS_LOAD_ERROR'

export const STUDENTS_WITHOUT_GROUP_LOAD_START = 'STUDENTS_WITHOUT_GROUP_LOAD_START'
export const STUDENTS_WITHOUT_GROUP_LOAD_SUCCESS = 'STUDENTS_WITHOUT_GROUP_LOAD_SUCCESS'
export const STUDENTS_WITHOUT_GROUP_LOAD_ERROR = 'STUDENTS_WITHOUT_GROUP_LOAD_ERROR'

export const ADD_STUDENTS_START = 'ADD_STUDENTS_START'
export const ADD_STUDENTS_SUCCESS = 'ADD_STUDENTS_SUCCESS'
export const ADD_STUDENTS_ERROR = 'ADD_STUDENTS_ERROR'

export const GROUP_CLEAR = 'GROUP_CLEAR'
export const GROUPS_CLEAR = 'GROUPS_CLEAR'

export const createGroup = (body) => ({ getState, fetch }) => ({
  type: 'GROUP_ADD',
  payload: apiPost({
    fetch,
    endpoint: 'group',
    getState,
    body,
  }),
})

export const editGroup = (body) => ({ getState, fetch }) => ({
  type: 'GROUP_EDIT',
  payload: apiPut({
    fetch,
    endpoint: `group/${body.id}`,
    getState,
    body,
  }),
})

export const loadGroup = (id) => ({ getState, fetch }) => ({
  type: 'GROUP_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `group/${id}`,
    getState,
  }),
})

export const deleteGroup = (id) => ({ getState, fetch }) => ({
  type: 'GROUP_DELETE',
  payload: apiDelete({
    fetch,
    endpoint: `group/${id}`,
    getState,
  }),
})

export const loadGroups = (query) => ({ getState, fetch }) => ({
  type: 'GROUPS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'group',
    getState,
    query,
  }),
})

export const getStudentsWithoutGroup = () => ({ getState, fetch }) => ({
  type: 'STUDENTS_WITHOUT_GROUP_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'group/students/without-group',
    getState,
  }),
})

export const addStudents = (id, body) => ({ getState, fetch }) => ({
  type: 'ADD_STUDENTS',
  payload: apiPost({
    fetch,
    endpoint: `group/${id}/add-students`,
    getState,
    body,
  }),
})

export const clearGroups = () => ({
  type: GROUPS_CLEAR,
})

export const clearGroup = () => ({
  type: GROUP_CLEAR,
})



// WEBPACK FOOTER //
// ./src/common/groups/actions.js